const initialState = {
  workItemId: null,
}

const HistorySidebarReducer = (state = initialState, action) => {
  switch(action.type){
    case 'SET_WORKITEM_ID':
      return {
        ...state,
        workItemId: action.id,
      }
    case 'SET_WORKVIEW_ERROR':
      return {
        ...state,
        error: action.error
      }
    case 'SET_WORKVIEW_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails
      }
    case 'SET_DRAWER_SHOWN':
      return {
        ...state,
        drawerShown: action.setDrawerShown
      }
  default:
    return state
  }
}

export default HistorySidebarReducer;